type FuncType = (...args: any[]) => void;

export function debounce(func: FuncType, delay: number): FuncType {
  let timerId: NodeJS.Timeout;

  return function (this: any, ...args: any[]) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this;
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}
